import Vue from 'vue'
import store from '@/store'
import * as types from '@/store/mutation-types'
import { storageNames } from '@/assets/js/const'

export default function Initializer () {
  console.log('bbb', Vue.ls.get(storageNames.alreadyWalletConnected))
  Vue.ls.get(storageNames.alreadyWalletConnected) && store.commit(types.SET_ALREADY_WALLET_CONNECTED, Vue.ls.get(storageNames.alreadyWalletConnected))
}
